import React, { useContext } from 'react';
import slugify from 'slugify';
import styled from 'styled-components';
import { UserContext } from '../../../../context/UserContext';
import { Badge } from '../../../ui';
import { variables } from '../../../utils';
import AdminSwitch from './AdminSwitch';
import RemoveMemberButton from './RemoveMemberButton';

const MemberListItem: any = styled.li.attrs({
  className: 'serif f6 pv2 bt b--light-gray flex items-center justify-between'
})`
  color: ${(p: any) => (p.member.role === 'PENDING' ? variables.moonGray : variables.navy)};
`;

interface MemberList {
  subject: {
    id: string;
  };
  subjectMembers: {
    id: string;
    roleType: string;
    member: {
      id: string;
      displayName: string;
      user: {
        id: string;
        email: string;
      };
    };
    membershipStatus: string;
  }[];
  userIsAdmin: boolean;
}

const MemberList: React.FC<MemberList> = ({ subject, subjectMembers, userIsAdmin }) => {
  const { user } = useContext(UserContext);

  return (
    <div className="bt b--light-gray">
      <p className="f7 tr mv2 fw5">Admin</p>

      <ul className="list ma0 pa0" data-testid="subject-members-list">
        {subjectMembers.map(subjectMember => {
          const { member } = subjectMember;
          return (
            <MemberListItem
              member={member}
              key={member.id}
              data-testid={`member-${slugify(member.displayName)}`}
            >
              <div className="flex items-center">
                {userIsAdmin && user.id !== member.user.id && (
                  <div className="mr1">
                    <RemoveMemberButton member={member} subject={subject} />
                  </div>
                )}
                <span className="mr1">{member.displayName || member.user.email}</span>
                {subjectMember.membershipStatus === 'PENDING' && (
                  <Badge className="ml1" data-testid="pending">
                    Pending
                  </Badge>
                )}
              </div>

              <AdminSwitch
                subjectMember={subjectMember}
                subject={subject}
                disabled={!userIsAdmin || user.id === member.user.id}
              />
            </MemberListItem>
          );
        })}
      </ul>
    </div>
  );
};

export default MemberList;
